var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1036.8 463.78c0.79688 58.219-22.5 115.08-65.484 158.11l-318.19 318.19c-14.062 14.062-33.094 21.984-53.016 21.984-19.922 0-38.953-7.9219-53.016-21.984l-318.24-318.24c-87.656-87.703-87.656-230.44 0-318.19 42.234-42.234 98.062-65.438 157.18-65.438 62.906 0 118.78 23.203 161.06 65.438l53.016 53.062 53.016-53.016c84.656-84.75 233.48-84.75 318.19 0 42.984 42.984 66.281 99.844 65.484 160.08z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.a50fadc0fdc954d9af1bb561fb0d4900.svg";
export { ForwardRef as ReactComponent };